import { createSlice } from "@reduxjs/toolkit";
import { GET_EXE_FILE,  } from "./thunk";

const ExeAndSetupFile = createSlice({
  name: "ExeAndSetupFile",
  initialState: {
    data: null,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
      state.success = false;
    },
  },

  extraReducers: (builder) => {
    builder
      // For Get VendorDashboardData
      .addCase(GET_EXE_FILE.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(GET_EXE_FILE.fulfilled, (state, action) => {
        state.success = true;
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(GET_EXE_FILE.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { resetState } = ExeAndSetupFile.actions;
export default ExeAndSetupFile.reducer;
